export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40d6b69703b197740307a4d9ea4b35140956056a82&name=revalidateCommunity!'